/**
* Standard route parameter names
*/
export const RouteParameterType = {
    'id': 'id',
    'agentId': 'agentId',
    'transactionTypeId': 'transactionTypeId',
    'sourceSystemTypeId': 'sourceSystemTypeId',
    'templateConfigurationName': 'templateConfigurationName',
    'routeConfigurationName': 'routeConfigurationName'
};
